<template>

    <v-dialog 
    v-model="archive.show"
    width="500">
    <v-card hover class="card-round pa-3">
      <p class="subheading text-center pa-3"> {{archive.description}} definitief verwijderen?</p>
      <v-layout justify-space-around>
        <v-flex xs4 class="text-center">
            <v-btn block rounded color="success" @click="closeArchiveDialog()" >Annuleren</v-btn>
        </v-flex>
        <v-flex xs4 class="text-center">
            <v-btn block rounded color="error" @click="deleteDialogItem()" >verwijderen</v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>    

</template>


<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  computed: {
    ...mapState(["archive"])
  },
  methods: {
    ...mapMutations(["closeArchiveDialog"]),
    ...mapActions(["deleteDialogItem"])
  }
};
</script>

<style scoped>
.card-round {
  min-height: 100px;
}
</style>


